import React, {useState} from "react";
import {updateQueryString} from "./lib/utils";
import DatePicker from "./DatePicker";

const SearchDate = props => {
  const [value, setValue] = useState(props.value || '');

  const handleChange = (val) => {
    setValue(val);
    updateQueryString({[props.name]: val || undefined});
  };

  return <DatePicker label={props.label} value={value} onChange={handleChange} />;
}

export default SearchDate;
